/* Price/compare-at discounts for Variant B collection links. Read-only, lazy,
   locale-aware and cached for this page; never show a partial collection maximum. */
(() => {
  if (customElements.get('ext-drawer-discount-loader')) return;
  const results = new Map();
  const mobile = window.matchMedia('(max-width: 749px)');

  async function collectionDiscount(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid collection URL');
    url.pathname = url.pathname.replace(/\/$/, '') + '/products.json';
    url.search = '';
    url.hash = '';
    url.searchParams.set('limit', '250');
    let highest = 0;
    const seen = new Set();
    for (let page = 1; ; page += 1) {
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Collection unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products)) throw new Error('Invalid collection response');
      for (const product of data.products) {
        if (seen.has(product.id)) throw new Error('Collection pagination did not advance');
        seen.add(product.id);
        for (const variant of product.variants || []) {
          const price = Number(variant.price);
          const compare = Number(variant.compare_at_price);
          if (Number.isFinite(price) && Number.isFinite(compare) && price > 0 && compare > price) {
            // Match Liquid's floor while avoiding floating point loss at whole percentages.
            highest = Math.max(highest, Math.floor((compare - price) * 100 / compare + 1e-9));
          }
        }
      }
      if (data.products.length < 250) return highest;
    }
  }

  customElements.define('ext-drawer-discount-loader', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('details');
      this.load = () => {
        if (!mobile.matches || !this.drawer?.open || (this.drawer.querySelector('.menu-drawer--ab') && !document.documentElement.classList.contains('nav-v2'))) return;
        this.querySelectorAll('[data-drawer-discount-collection]').forEach(async (badge) => {
          const path = badge.dataset.drawerDiscountCollection;
          if (!results.has(path)) results.set(path, collectionDiscount(path).catch(() => null));
          const percent = await results.get(path);
          if (!badge.isConnected || !(percent > 0)) return;
          badge.textContent = `Up to ${percent}% OFF`;
          badge.hidden = false;
        });
      };
      this.drawer?.addEventListener('toggle', this.load);
      mobile.addEventListener('change', this.load);
      this.variantObserver = new MutationObserver(this.load);
      this.variantObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.load();
    }

    disconnectedCallback() {
      this.drawer?.removeEventListener('toggle', this.load);
      mobile.removeEventListener('change', this.load);
      this.variantObserver.disconnect();
    }
  });
})();
